(function($) {
  $(window).ready(function() {

    
    setFiltersOnLoad();

    $('.clear-filters button').on('click', function() {
        $('.fancy-checkbox-menu').each(function(index) {
            $(this).find('.dropdown-list input[type=checkbox]').each(function() { $(this).prop('checked',false); });
        });       
        $('input.job-keyword-search[type=search]').val('')
        var newQS = buildQS();
        if ( newQS != window.location.search ) { 
          if (history.pushState) { history.pushState(null, null, window.location.pathname + newQS); }
        }
        //update filter status
        $('.fancy-checkbox-menu').fancyCheckboxMenu();
        jobLevelFilter();
    });

    $('.more-jobs button').on('click', function() {
        var This = $(this);
        This.parent().toggleClass('open').toggleClass('closed');
        This.parent().parent().parent().toggleClass('short');
        seeMoreLess($(this).parent().parent().parent());
        if (This.parent().hasClass('closed')) {
          $('html, body').animate({ scrollTop: ( parseInt( This.parent().parent().parent().offset().top) -200 ).toString() });        
        }
    });

    $numToShow = parseInt($('.jobs-list').attr('data-num-to-show'));
    function seeMoreLess( departmentJobsList ) {
      $list = departmentJobsList;
      $visibleJobs = $list.find($('.job-item[data-is-show="true"]'));
      if ( departmentJobsList.hasClass('short') ) {
          $count = 0;
          $visibleJobs.each(function(index) {
            if ($count < $numToShow) { $(this).show(); $count++; }
            else {  $(this).hide(); }
          });       
      }
      else {
        $visibleJobs.each(function(index) {  $(this).show(); });     
      }
    }

    /* attempt to make job list headings sticky  */
    var jobListHeaderTop = $('.job-list-thead').offset().top;       // get initial position of the element
    $(window).scroll(function() {                  // assign scroll event listener
        var currentScroll = $(window).scrollTop(); // get current position
        var jobListWidth = $('.job-list-tbody').width() + 'px';
        if ( (currentScroll+90) >= jobListHeaderTop && $('.job-list-thead').is(":visible") ) { 
            $('.site__header__navigation__primary').addClass('no-border');
        }
        else {
            $('.site__header__navigation__primary').removeClass('no-border');
        }
        if ( (currentScroll+45) >= jobListHeaderTop && $('.job-list-thead').is(":visible") ) {           // apply position: fixed if you
            $('.site__header__navigation__primary').addClass('no-border');
            $('.job-list-thead').css({                     
                position: 'fixed',
                top: '0',
                padding: '105px 0px 16px 0px'
            });
            $('.job-list-tbody').css({                      
              padding: '90px 0px 0px 0px'
            });
            $('.job-list-thead').width(jobListWidth);
        } else {                                   // apply position: static
            $('.job-list-thead').css({                      // if you scroll above it
                position: 'static',
                padding: '64px 0px 16px 0px',
                width: 'auto'
            });
            $('.job-list-tbody').css({                     
              padding: '0px'
            });
            //$('.site__header__navigation__primary').removeClass('no-border');
        }
    });
    $(window).on('resize', function() {
        if ($('.job-list-thead').css("position") === "fixed" && $('.job-list-thead').is(":visible")) {
          var jobListWidth = $('.job-list-tbody').width() + 'px';
          $('.job-list-thead').width(jobListWidth);
        }
    });

    function jobLevelFilter(changedElement = null) {
        $('.no-jobs').hide();
        $('.job-item').hide().attr('data-is-show', 'false').removeClass("firstVisible");
        $('.team-row').hide().removeClass("firstVisible");

        //if ( $('#switch_remote').prop('checked') ) { 
        //   $('.job-item[data-remote-job="true"]').attr('data-is-show', 'true');
        //}
        //else {
          $('.job-item').attr('data-is-show', 'true');        
        //}

        if (changedElement != null && changedElement.parent('.option-parent').length) {  /* if the target element was a "parent", apply same to children */
          var parentSelected = changedElement.prop('checked');
          changedElement.parent().parent().find('.option-child input.check').each(function(index) {
            $(this).prop('checked', parentSelected);
          });
          //$('.fancy-checkbox-menu').fancyCheckboxMenu();
        }

        if (changedElement != null && changedElement.parent('.option-child').length) {  /* if the target element was a "child"... */
          var unselectedChildren = changedElement.parent().parent().find('.option-child input.check:not(:checked)')
          var parentoption = changedElement.parent().parent().find('.option-parent input.check');
          if (unselectedChildren.length) {
            parentoption.prop('checked', false);
          }
          else {
            parentoption.prop('checked', true);          
          }
          //$('.fancy-checkbox-menu').fancyCheckboxMenu();
        }

        var checkedItems = $('#team-list .check:checkbox:checked');
        if (checkedItems.length > 0) { 
          var teamSelectedValues = [];
          checkedItems.each(function(index) {
            teamSelectedValues.push($(this).attr('id').split("_").pop());
          });

          console.log('teamSelectedValues', teamSelectedValues);
          
          $('.job-item[data-is-show="true"]').each(function(index) {
            //console.log($(this));
              var itemValue = $(this).attr('data-department-id');

              console.log('itemValue', itemValue);

              var team_is_matching=teamSelectedValues.filter(function(itm){
                return itemValue.indexOf(itm)!=-1;
              });

              if (team_is_matching.length == 0 ) { 
                $(this).attr('data-is-show', 'false'); 
              }
          });       
        }

        checkedItems = $('#location-list .check:checkbox:checked');
        if (checkedItems.length > 0) { 
          var locSelectedValues = [];
          checkedItems.each(function(index) {
            locSelectedValues.push($(this).attr('id').split("_").pop());
          });
          
          $('.job-item[data-is-show="true"]').each(function(index) {
              var itemValue = $(this).attr('data-job-location');

              var loc_is_matching=locSelectedValues.filter(function(itm){
                return itemValue.indexOf(itm)!=-1;
              });

              if (loc_is_matching.length == 0 ) { $(this).attr('data-is-show', 'false'); }
          });       
        }

        checkedItems = $('#jobtype-list .check:checkbox:checked');
        if (checkedItems.length > 0) { 
          var typeSelectedValues = [];
          checkedItems.each(function(index) {
            typeSelectedValues.push($(this).attr('id').split("_").pop());
          });
          
          $('.job-item[data-is-show="true"]').each(function(index) {
              var itemValue = $(this).attr('data-job-type');

              var type_is_matching=typeSelectedValues.filter(function(itm){
                return itemValue.indexOf(itm)!=-1;
              });

              if (type_is_matching.length == 0 ) { $(this).attr('data-is-show', 'false'); }
          });       
        }

        if ( $('input.job-keyword-search[type=search]').val().trim() != '' ) {
          keywordSearchfilter();
        }

        updateDisplay();
    }

    function updateDisplay() {
      var foundFirstVisibleTeam = false;
      $('.team-row').each(function(index) { /* $('.team-row[data-is-show="true"]') */
        $visibleJobs = $(this).find($('.job-item[data-is-show="true"]'));
        if ( $visibleJobs.length > 0 ) { 
          if ($visibleJobs.length > $numToShow) { 
            $(this).find($('.more-jobs')).removeClass('hidden').removeClass('open').addClass('closed');
            $(this).find( $('.department-jobs') ).addClass('short');
          } 
          else { 
            $(this).find($('.more-jobs')).addClass('hidden').removeClass('open').removeClass('closed');
            $(this).find( $('.department-jobs') ).removeClass('short');
          }
          $(this).show(); 
          $(this).attr('data-is-show', 'true');
          if (!foundFirstVisibleTeam) { $(this).addClass("firstVisible"); foundFirstVisibleTeam = true; }
          $visibleJobs.eq(0).addClass("firstVisible"); 
        }
        else {
          $(this).attr('data-is-show', 'false');
          $(this).hide();
        }
        $(this).find('.department-jobs').addClass('short');
        seeMoreLess( $(this).find('.department-jobs') );
      });  
      var visibleJobs = $('.team-row .job-item[data-is-show="true"]').length;
      var totalJobs = $('.team-row .job-item').length;
      if ( visibleJobs == 0 ) { 
        $('.no-jobs').show(); 
      }
      else {
        if (totalJobs == visibleJobs) {
          $('.clear-filters').hide();
        }
        else {
          $('.clear-filters').show();
        }
        $('.role-count .filter-count').text(visibleJobs);
        if (visibleJobs == 1) {
          $('.role-count .filter-text').text(' '+roleString);
        }
        else {
          $('.role-count .filter-text').text(' '+roleStringPl);
        }
        const teamsSelected = $('#team-list .check:checkbox:checked').length;
        if (teamsSelected == 0) {
          $('.team-count .filter-count').text("");
          $('.team-count .filter-text').text(allString+' '+teamStringPl);
        }
        else if (teamsSelected == 1 ) {
          $('.team-count .filter-count').text(teamsSelected);
          $('.team-count .filter-text').text(' '+teamString);
        }
        else if (teamsSelected > 1) {
          $('.team-count .filter-count').text(teamsSelected);
          $('.team-count .filter-text').text(' '+teamStringPl);
        }
        const locsSelected = $('#location-list .check:checkbox:checked').length;
        if (locsSelected == 0) {
          $('.location-count .filter-count').text("");
          $('.location-count .filter-text').text(allString+' '+locationStringPl);
        }
        else if (locsSelected == 1 ) {
          $('.location-count .filter-count').text(locsSelected);
          $('.location-count .filter-text').text(' '+locationString);
        }
        else if (locsSelected > 1) {
          $('.location-count .filter-count').text(locsSelected);
          $('.location-count .filter-text').text(' '+locationStringPl);
        }
        const typesSelected = $('#jobtype-list .check:checkbox:checked').length;
        if (typesSelected == 0) {
          $('.jobtype-count .filter-count').text("");
          $('.jobtype-count .filter-text').text(allString+' '+typeStringPl);
        }
        else if (typesSelected == 1 ) {
          $('.jobtype-count .filter-count').text(typesSelected);
          $('.jobtype-count .filter-text').text(' '+typeString);
        }
        else if (typesSelected > 1) {
          $('.jobtype-count .filter-count').text(typesSelected);
          $('.jobtype-count .filter-text').text(' '+typeStringPl);
        }
        $('.no-jobs').hide(); 
      }

      const newQS = buildQS();
      if ( newQS != window.location.search ) { 
        if (history.pushState) { history.pushState(null, null, window.location.pathname + newQS); }
      }
    }

    //$('#team-list .check, #team-list .check-all, #location-list .check, #location-list .check-all, #jobtype-list .check, #jobtype-list .check-all').change(function() {
    //$(' #location-list .check, #location-list .check-all, #jobtype-list .check, #jobtype-list .check-all').change(function() {
    $('#team-list .check, #team-list .check-all, #location-list .check, #location-list .check-all, #jobtype-list .check, #jobtype-list .check-all').change(function() {
        jobLevelFilter($(this));
    });
    jobLevelFilter();

    $('input.job-keyword-search[type=search]').on('search', function(event){
      event.preventDefault();
      if(this.value){
        //alert ("we're searching now!");
        jobLevelFilter();
        keywordSearchfilter();
        updateDisplay();
      }
      else {
        //alert ("Search cleared???");
        jobLevelFilter();
      }
      return false;
    });

    $('input.job-keyword-search[type=search]').on('keyup', function(event) {
      const key = event.code || event.keyCode;
      if ( key === 'Enter' || key === 13 ) { 
        this.blur(); 
      }
    });

    function keywordSearchfilter() {
      const rawSearchString = $('input.job-keyword-search[type=search]').val().replace(/^\s+|\s+$/g, " ");
      const searchterms = rawSearchString.split(" ");

      $('.job-item[data-is-show="true"]').each(function(){
        var currentItem = $(this);
        var itemSelected=false;
        jQuery.each( searchterms, function( i, val ) {
          var test = currentItem.attr('data-dept-names').toLowerCase();
          if ( currentItem.attr('data-dept-names').toLowerCase().indexOf(val.toLowerCase()) !== -1 )  { 
            itemSelected = true; 
          }
          else {
            if ( currentItem.find('.job-title').text().toLowerCase().indexOf(val.toLowerCase()) !== -1 ) { 
              itemSelected = true; 
            }
          }
        });
        if (!itemSelected) {
          currentItem.attr('data-is-show', 'false');
        }
      });
    }


    function buildQS() {
        var query_string = '';

        var checkedItems = $('#location-list .check:checkbox:checked');
        var locSelectedValues = [];
        if (checkedItems.length > 0) { 
          checkedItems.each(function(index) { locSelectedValues.push($(this).attr('id').split("_").pop()); });
        }

        checkedItems = $('#jobtype-list .check:checkbox:checked');
        var typeSelectedValues = [];
        if (checkedItems.length > 0) { 
          checkedItems.each(function(index) { typeSelectedValues.push($(this).attr('id').split("_").pop()); });
        }

       // var remoteSelectedValues = [];
       // if ( $('#switch_remote').prop('checked') ) { 
       //   remoteSelectedValues.push('yes');
        //}

        checkedItems = $('#team-list .check:checkbox:checked');
        var teamSelectedValues = [];
        if (checkedItems.length > 0) {  // no filters selected
          checkedItems.each(function(index) { teamSelectedValues.push($(this).attr('id').split("_").pop()); });
        }

        var qs_vals = [];
        if ( teamSelectedValues.length > 0 ) { qs_vals.push('team='+teamSelectedValues.join('||')); }
        if ( locSelectedValues.length > 0 ) { qs_vals.push('loc='+locSelectedValues.join('||')); }
        if ( typeSelectedValues.length > 0 ) { qs_vals.push('type='+typeSelectedValues.join('||')); }
        var searchterms = $('input.job-keyword-search[type=search]').val().trim();
        if ( searchterms != '' ) { qs_vals.push('search='+encodeURIComponent(searchterms)); }
        //if ( remoteSelectedValues.length > 0 ) { qs_vals.push('remote='+remoteSelectedValues.join('||')); }
      
        if (qs_vals.length > 0) { query_string = '?' + qs_vals.join('&'); }

        return query_string;
  }

  function setFiltersOnLoad() {
      var $query_string = decodeURIComponent(window.location.search.replace('?','')).replace(/[.*+^${}()<>[\]\\]/g, '');
      var $params = $query_string.split('&');
      if ($params.length > 0 ) {
        for (var index = 0; index < $params.length; index++) { 
          var param_name = $params[index].split('=')[0];
          if (param_name == 'team') {  
            var teamSelectedValues = $params[index].split('=')[1].split('||');
            for (var i = 0; i < teamSelectedValues.length; i++) {
              var $chkbox = $('#checkbox-teams_'+ teamSelectedValues[i]).prop('checked', true).trigger('change');
            } 
          }
          if (param_name == 'loc') {  
            var locSelectedValues = $params[index].split('=')[1].split('||');
            for (var i = 0; i < locSelectedValues.length; i++) {
              var $chkbox_id = '#checkbox-locations_'+ locSelectedValues[i].replace(' ', '-');
              var $chkbox = $($chkbox_id);
              $chkbox.prop('checked', true).trigger('change');
            } 
          }
          if (param_name == 'type') {  
            var typeSelectedValues = $params[index].split('=')[1].split('||');
            for (var i = 0; i < typeSelectedValues.length; i++) {
              var $chkbox_id = '#checkbox-jobtypes_'+ typeSelectedValues[i].replace(' ', '-');
              var $chkbox = $($chkbox_id);
              $chkbox.prop('checked', true).trigger('change');
            } 
          }
          if (param_name == 'search') { 
            if ($params[index].split('=')[1].length > 0 ) {
              $('input.job-keyword-search[type=search]').val(decodeURIComponent($params[index].split('=')[1]));
              $('input.job-keyword-search[type=search]').trigger('search');
            }
          }
          //if (param_name == 'remote') { 
          //  $('#switch_remote').prop('checked', true).trigger('change');
          //}
        }
      }
  }
  });
})(jQuery);